export default __webpack_public_path__ + "static/media/Instanceadmin.a4789fa4.svg";